import { Group, Button, Text, Stack } from '@mantine/core';
import { rem } from '@mantine/core';
import { formatWeight } from '../utils/formatWeight';

export default function VariantSelector({ variants, selectedVariant, onChange }) {
  if (!variants || variants.length <= 1) return null;

  return (
    <Stack gap="xs">
      <Text size="xs" fw={700} tt="uppercase" lts={1} c="dimmed">
        Select Weight
      </Text>
      <Group gap="xs" role="radiogroup" aria-label="Product weight options">
        {variants.map((variant) => {
          const isSelected = selectedVariant?.id === variant.id;
          const weightLabel = variant.weight_value != null
            ? formatWeight(variant.weight_value, variant.weight_unit)
            : variant.sku;

          return (
            <Button
              key={variant.id}
              variant={isSelected ? 'filled' : 'outline'}
              color={isSelected ? 'blue' : 'gray'}
              radius="md"
              size="lg"
              onClick={() => onChange(variant)}
              aria-pressed={isSelected}
              role="radio"
              aria-checked={isSelected}
              aria-label={`${weightLabel} variant`}
              style={{
                minWidth: rem(80),
                fontWeight: isSelected ? 800 : 500,
                borderWidth: isSelected ? 2 : 1,
              }}
            >
              <Text size="lg" fw={isSelected ? 800 : 600} tt="uppercase" style={{ whiteSpace: "nowrap" }}>
                {variant.weight_value != null
                  ? `${Number.isInteger(variant.weight_value) ? variant.weight_value : variant.weight_value.toFixed(1)}${variant.weight_unit || ""}`
                  : variant.sku}
              </Text>
            </Button>
          );
        })}
      </Group>
    </Stack>
  );
}
